<template>

    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <label for="name">Nama Negara </label>
                <input type="text" v-model="model.name" class="form-control" readonly>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label for="name">Kode Negara </label>
                <input type="text" v-model="model.code" class="form-control" readonly>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            model: {
                name: this.detail?.name,
                id: this.detail?.id,
                code: this.detail?.code
            }
        }
    },
    methods: {
        resetModel() {
            this.model = { name: '', id: '', code: '' }
        },
        editMode(item) {
            this.model.name = item.name
            this.model.id = item.id
            this.model.code = item.code
        },
    }
}
</script>